import { Overrides } from '@material-ui/core/styles/overrides';

export const MuiOrderSummaryTotals: Overrides['MuiOrderSummaryTotals'] = {
  remove: {
    margin: '7px 10px',
  },
};
